var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import OtPdf from './ot-pdf';
import { Button, Card, CardBody, Col } from 'reactstrap';
var OtPdfViewer = /** @class */ (function (_super) {
    __extends(OtPdfViewer, _super);
    function OtPdfViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            ot: JSON.parse(localStorage.getItem("ot")),
            customer: JSON.parse(localStorage.getItem("customer"))
        };
        localStorage.removeItem("ot");
        localStorage.removeItem("customer");
        return _this;
    }
    OtPdfViewer.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(Col, { md: 1, lg: 1, xl: 1 },
                React.createElement(Button, { onClick: this.props.history.goBack }, "\u2190 Volver"),
                React.createElement("p", null)),
            React.createElement(Col, { md: 12, lg: 12, xl: 12 },
                React.createElement(Card, { style: { height: '100%' } },
                    React.createElement(CardBody, null,
                        React.createElement(PDFViewer, { style: { width: '100%', height: '1000px', } },
                            React.createElement(OtPdf, { ot: this.state.ot, customer: this.state.customer })))))));
    };
    return OtPdfViewer;
}(React.Component));
export default OtPdfViewer;
